import spotifyImage from '../images/spotifyplaylistgenerator.png';

const projects = [
    {
        title:"Spotify Playlist Generator",
        image: spotifyImage,
        description: "A Flask web application to autogenerate Spotify playlists from a user's Spotify recommendations. This project was built with Python, powered by the Spotify Web API, and deployed to Heroku.",
        stack: ["Python3", "Flask", "Spotify Web API", "Spotify oEmbed API", "Oauth2.0"],
        source: "https://github.com/serenagibbons/spotify-playlist-generator",
        url: "https://playlistgeneratorforspotify.herokuapp.com/"
    }
];

export default projects;